import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { EventTrackerService } from '@core/services/event-tracker.service';
import {
    FeatureFlagService,
    FeatureFlags,
} from '@core/services/feature-flag.service';
import { ANALYTICS_EVENTS } from '@core/utils/AnalyticsEvents';
import { ModalService } from '@features/modal/services/modal.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Trip } from '@generated/graphql';
import { LeadRequestCreatePolymorphicTypes as LeadRequestType } from '@generated/openapi/model/leadRequestCreatePolymorphicTypes';
import { PublicDeparture } from '@generated/openapi/model/publicDeparture';
import { CtaButtonComponent } from '@shared/cta-button/cta-button.component';
import { EnquireFormModalComponent } from '@shared/enquire-form-modal/enquire-form-modal.component';
import { DepartureWithDates } from '../trips-trip-self-booking/trips-trip-self-booking.component';
@Component({
    selector: 'app-trips-trip-self-booking-departure-detail',
    imports: [CommonModule, FontAwesomeModule, CtaButtonComponent],
    templateUrl: './trips-trip-self-booking-departure-detail.component.html',
})
export class TripsTripSelfBookingDepartureDetailComponent implements OnInit {
    open: boolean;
    openTooltip: boolean = false;
    isGuaranteed: boolean = false;
    isSoldOut: boolean = false;
    faArrowRight = faArrowRight;
    selfBookingFeatureFlagSignal = this.featureFlagService.getFeatureFlag(
        FeatureFlags.SELF_BOOKING
    );
    @Input() departure: DepartureWithDates;
    @Input() trip: Trip;
    @Input() isItineraryPage: boolean = false;
    toggleOpen() {
        this.open = !this.open;
    }

    public get DisplayStatusEnum() {
        return PublicDeparture.DisplayStatusEnum;
    }

    constructor(
        private modalService: ModalService,
        private eventTrackerService: EventTrackerService,
        public elRef: ElementRef,
        private featureFlagService: FeatureFlagService
    ) {}

    ngOnInit(): void {
        this.isGuaranteed = this.departure.status === 'GUARANTEED';
        this.isSoldOut = this.departure.status === 'SOLD_OUT';
    }

    toggleOpenTooltip() {
        this.openTooltip = !this.openTooltip;
    }

    join(departure: PublicDeparture) {
        if (this.isItineraryPage) {
            this.eventTrackerService.trackEvent(
                ANALYTICS_EVENTS.ITINERARY_ENQUIRE,
                {
                    trip: this.trip.title,
                    itinerary: this.departure.itinerary,
                    departure: departure.title,
                }
            );
        } else {
            this.eventTrackerService.trackEvent(ANALYTICS_EVENTS.TRIP_ENQUIRE, {
                trip: this.trip.title,
                departure: departure.title,
            });
        }
        this.modalService.show(
            EnquireFormModalComponent,
            {
                departure: departure,
                trip: this.trip,
                typeOfEnquiry: LeadRequestType.DepartureLeadRequest,
                analyticsEventSent: ANALYTICS_EVENTS.TRIP_ENQUIRY_SENT,
                analyticsEventCompleted:
                    ANALYTICS_EVENTS.TRIP_ENQUIRY_COMPLETED,
                analyticsEventAbandoned:
                    ANALYTICS_EVENTS.TRIP_ENQUIRY_ABANDONED,
                analyticsEventData: {
                    trip: this.trip.title,
                    departure: departure.title,
                },
            },
            false
        );
    }
}
